/**
 * Simple Dark Mode Toggle - NightShift
 * Compatible with Tailwind CSS classes
 */
document.addEventListener('DOMContentLoaded', function() {
    const themeOptions = document.querySelectorAll('.gh-nightshift-option');
    const prefersDarkScheme = window.matchMedia('(prefers-color-scheme: dark)');

    // Set initial theme based on saved preference or system preference
    const savedTheme = localStorage.getItem('dark-mode');
    if (savedTheme === 'auto') {
        setDarkMode(prefersDarkScheme.matches);
        setActiveOption('auto');
    } else if (savedTheme) {
        setDarkMode(savedTheme === 'dark');
        setActiveOption(savedTheme);
    } else {
        setDarkMode(prefersDarkScheme.matches);
        setActiveOption('auto');
        localStorage.setItem('dark-mode', 'auto');
    }

    // Handle theme option clicks
    themeOptions.forEach(option => {
        option.addEventListener('click', () => {
            const theme = option.getAttribute('data-dark-mode');
            if (theme === 'auto') {
                localStorage.setItem('dark-mode', 'auto');
                setDarkMode(prefersDarkScheme.matches);
            } else {
                localStorage.setItem('dark-mode', theme);
                setDarkMode(theme === 'dark');
            }
            setActiveOption(theme);
        });
    });

    // Listen for system color scheme changes when in auto mode
    prefersDarkScheme.addEventListener('change', (e) => {
        if (localStorage.getItem('dark-mode') === 'auto') {
            setDarkMode(e.matches);
        }
    });

    function setDarkMode(enable) {
        document.documentElement.classList.toggle('dark', enable);
        document.documentElement.dataset.darkMode = enable ? 'dark' : 'light';
    }

    function setActiveOption(theme) {
        themeOptions.forEach(option => {
            option.classList.toggle('active', option.getAttribute('data-dark-mode') === theme);
        });
    }
});